import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=35515918&scoped=true&"
import script from "./EmptyList.vue?vue&type=script&lang=js&"
export * from "./EmptyList.vue?vue&type=script&lang=js&"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=35515918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35515918",
  null
  
)

export default component.exports